import {
  isDevAppHost,
  isDevDataDeletionHost,
  isProductionCloneAppHost,
  isTrainingAppHost,
} from "@/lib/platform";

/** Welche Dev-/Test-Werkzeuge auf dem aktuellen Host sichtbar sind */
export function devToolsVisibility() {
  const showDemoSeedTools = isTrainingAppHost();
  const showClearTestData = isDevDataDeletionHost();
  const showPublishProduction = isDevAppHost();
  const showProductionClone = isProductionCloneAppHost();
  return {
    showDemoSeedTools,
    showClearTestData,
    showPublishProduction,
    showProductionClone,
    any: showDemoSeedTools || showClearTestData || showPublishProduction || showProductionClone,
  };
}
